

<template>
	<div class="pdf-viewer">
		<a @click="$emit('close-pdf-clicked', $event)" class="close p-4 mr-7 mt-3" v-if="showClose">
			<i class="fal fa-times"></i>
		</a>

		<div class="pdf-pages" v-if="!useIFrame && currentSrc">

			<div class="d-none">
				<pdf ref="pdfTester" :src="currentSrc" :page="1" @error="onError" @loaded="onLoaded" @page-loaded="currentPage = $event" @num-pages="numPages = $event"></pdf>
			</div>

			<div class="page-wrap" v-if="numPages > 0" v-for="i in numPages">
				<pdf 
					ref="pdfRenderer"
					:key="i"
					:src="currentSrc"
					:page="i"
					@loaded="onLoaded(numPages, i)"
					@error="onError"
				></pdf>
			</div>
		</div>

		<div class="pdf-pages" v-if="useIFrame && currentSrc">
			<iframe :src="currentSrc"></iframe>
			<!-- <object :src="currentSrc" width="100%" height="100%"></object> -->
		</div>
	</div>

</template>

<script>

import pdf from 'vue-pdf'

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'

export default {
	store,
	props: ['src'],
	components: {
		pdf
	},
	data: () => {
		return {
			useIFrame: false,
			loadingTask: false,
			numPages: 0,
			currentPage: 0,
			currentSrc: false,
			scale: 'page-width',
			timer: false,
			showClose: false,
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},
	watch: {
		src( newPDF ) {
			console.log(`PDF changed to: ${newPDF}`);
			this.numPages = 0;
			this.currentPage = 0;
			this.loadPDF( newPDF );
		}
	},
	mounted() {
		if (this.src) {
			this.loadPDF( this.src );
		}
	},
	beforeDestroy() {
		this.destroyPDFRenderer();
	},	
	methods: {
		loadPDF( newPDF ) {
			this.destroyPDFRenderer();
			this.currentSrc = false;
			this.timer = setTimeout(() => {
				this.currentSrc = newPDF;
				console.log(`PDF now loading: ${this.currentSrc}`);
			}, 300);
		},

		destroyPDFRenderer() {
			clearTimeout( this.timer );
			var items = [];
			if (this.$refs.pdfTester) {
				items.push(this.$refs.pdfTester);
			}
			if (this.$refs.pdfRenderer) {
				items.push( ...this.$refs.pdfRenderer );
			}
			items.forEach((item) => {
				if (item.pdf) {
					console.log('destroyed: ', item);
					item.pdf.destroy();
				}
			});
		},
		reset() {
			this.currentSrc = false;
		},
		onLoaded( numPages, loadNum ) {
			this.showClose = false;
			if (loadNum >= numPages) {
				setTimeout(() => {
					this.showClose = true;
				}, 1500);
			}
			console.log(`PDF loaded: ${loadNum}/${numPages}`);
		},
		onError( error ) {
			console.log(`PDF ERROR:`, error);
		},
		getPdf () {
			var self = this;
			this.numPages = 0;
			this.loadingTask = pdf.createLoadingTask( this.src ).then(pdf => {
				this.numPages = pdf.numPages;
			}).catch(( error ) => {
				console.log( error );
			});
		},

	}

}
</script>

<style scoped lang="scss">
	iframe {
		width: 100%;
		height: 100%;
		border: none;
	}
	.pdf-viewer {
		@include position( absolute, 20px 20px 20px 20px, 150 );
		background-color: #fff;
		box-shadow: 0 0 15px rgba(#000, 0.2);
		background: #aaa;
	}
	.pdf-pages {
		overflow-y: auto;
		padding: 40px 0 40px 0;
		@include position( absolute, 0 0 0 0, 150 );
	}
	.page-wrap {
		margin: 0 auto 40px auto;
		box-shadow: 0 0 10px rgba(#000, 0.4);
		background: #fff;
		width: 80%;
	}
	.close {
		font-size: 2.5rem;
		@include position( absolute, 0 0 auto auto, 160 );
	}
</style>
